import * as React from "react";
import {
  createFileRoute,
  useNavigate,
  useSearch,
  Link,
  // useSearchLink
} from "@tanstack/react-router";
// helpers
import { useAccessPermission } from "@/helpers/acessPermission";
// UI
import NotPermission from "@/components/NotPermission";
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
} from "@/components/ui/card";
import {
  Yourself,
  Board,
  Workplace,
  Government,
} from "@/components/tables/TableDirector";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ArrowLeft } from "lucide-react";
export const Route = createFileRoute(
  "/_layout-private/report/director/details/"
)({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      active: search.active as Tab,
    };
  },
});

type Tab = "yourself" | "board" | "workplace" | "Government";

function RouteComponent() {
  const navigate = useNavigate();
  const { active } = Route.useSearch();
  const { director_Evaluation_Report } = useAccessPermission();
  // console.log("Active", active);

  // Define the tab change handler to update the query parameter
  const handleTabChange = (value: Tab) => {
    // setSearch({ tab: value });

    // console.log(value, "Tab");

    navigate({
      to: "/report/director/details",
      search: {
        active: value,
      },
    });
  };
  const toYourself = localStorage.getItem("yourself_director"); // Get year from local storage
  const toBoard = String(localStorage.getItem("board_director")); // Get year from local storage
  const toWorkplace = String(localStorage.getItem("workplace_director")); // Get year from local storage
  const toGovernment = String(localStorage.getItem("government_director")); // Get year from local storage

  return director_Evaluation_Report.isRead ? (
    <div>
      <Breadcrumb>
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink>
              <Link to="/report/director ">ລາຍງານແຜນດຳເນີນງານ</Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>ການປະເມີນຄະນະອຳນວຍການ</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
      <Card className="mt-8">
        <CardHeader className="border-b">
          <button
            type="button"
            onClick={() => {
              try {
                navigate({
                  to: "/report/director",
                  replace: true,
                });
              } catch (error) {
                console.error("Navigation error:", error);
              }
            }}
            className="flex gap-1 items-center mb-4"
            aria-label="Go back to tax obligations report"
          >
            <ArrowLeft className="w-5 h-5" />
            ກັບຄືນ
          </button>
          <CardTitle>ການປະເມີນຄະນະອຳນວຍການ</CardTitle>
          <CardDescription>ລາຍການການປະເມີນ </CardDescription>
        </CardHeader>
        <CardContent>
          <Tabs
            value={active || "yourself"}
            defaultValue={active || "yourself"}
            onValueChange={
              // (value) => console.log("Tab Value", value)
              (value) => handleTabChange(value as Tab)
            }
            className="flex flex-col gap-y-12 mt-5"
          >
            <TabsList className="flex flex-wrap gap-2 justify-start items-start bg-transparent">
              <TabsTrigger
                value="yourself"
                className="px-3 bg-gray-100 rounded-full text-black data-[state=active]:bg-green-500 data-[state=active]:text-white"
              >
                ປະເມີນຕົນເອງ
              </TabsTrigger>
              <TabsTrigger
                value="board"
                className="px-3 bg-gray-100 rounded-full text-black data-[state=active]:bg-green-500 data-[state=active]:text-white"
              >
                ຄະນະປະເມີນ
              </TabsTrigger>
              <TabsTrigger
                value="workplace"
                className="px-3 bg-gray-100 rounded-full text-black data-[state=active]:bg-green-500 data-[state=active]:text-white"
              >
                ສັງກັດ
              </TabsTrigger>
              <TabsTrigger
                value="Government"
                className="px-3 bg-gray-100 rounded-full text-black data-[state=active]:bg-green-500 data-[state=active]:text-white"
              >
                ຂັ້ນເທິງຖັດ
              </TabsTrigger>
            </TabsList>

            <TabsContent value="yourself">
              <Yourself formTypeId={toYourself} />
            </TabsContent>
            <TabsContent value="board">
              <Board formTypeId={toBoard} />
            </TabsContent>
            <TabsContent value="workplace">
              <Workplace formTypeId={toWorkplace} />
            </TabsContent>
            <TabsContent value="Government">
              <Government formTypeId={toGovernment} />
            </TabsContent>
          </Tabs>
        </CardContent>
      </Card>
    </div>
  ) : (
    <NotPermission />
  );
}
